import {NgModule} from '@angular/core';
import {RequestPasswordResetComponent} from './request-password-reset/request-password-reset.component';
import {PasswordResetComponent} from './password-reset.component';
import {NgxPermissionsModule} from 'ngx-permissions';
import {RouterModule} from '@angular/router';
import {routes} from './password-reset.routing';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {LoadingModule} from 'ngx-loading';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SharedModule} from '../../modules/shared.module';

@NgModule({
    imports: [
        NgxPermissionsModule.forChild(),
        RouterModule.forChild(routes),
        ReactiveFormsModule,
        CommonModule,
        SharedModule,
        FormsModule,
        LoadingModule,
        NgbModule
    ],
    providers: [],
    declarations: [
        RequestPasswordResetComponent,
        PasswordResetComponent
    ],
    entryComponents: []
})
export class PasswordResetModule { }



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/auth/password-reset/password-reset.module.ts